import React from 'react';
import PropTypes from 'prop-types';
import './eventCards.css';

const RelatedEventCard = ({
  title,
  date,
  location,
  language,
  onViewDetails,
  onShare,
  ctaLabel,
  variants,
  className = '',
  ...rest
}) => {
  return (
    <article className={`event-card related-event-card ${className}`.trim()} {...rest}>
      <div>
        <h4 className="related-event-card__title">{title}</h4>
        {date && location && (
          <p className="related-event-card__date-location">
            {date} | {location}
          </p>
        )}
        {language && (
          <p className="related-event-card__language">
            {language}
          </p>
        )}
      </div>

      <button type="button" className="related-event-card__cta" onClick={onViewDetails}>
        {ctaLabel}
      </button>

    </article>
  );
};

RelatedEventCard.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  location: PropTypes.string.isRequired,
  language: PropTypes.string,
  onViewDetails: PropTypes.func,
  onShare: PropTypes.func,
  ctaLabel: PropTypes.string,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
      onSelect: PropTypes.func,
    })
  ),
  className: PropTypes.string,
};

RelatedEventCard.defaultProps = {
  date: '',
  language: '',
  onViewDetails: () => {},
  onShare: undefined,
  ctaLabel: 'View Details',
  variants: [],
  className: '',
};

export default RelatedEventCard;

